import { Path, Svg } from '@react-pdf/renderer'

export const WorkflowIcon = () => (
  <Svg height={14} viewBox='0 0 58 58' width={14}>
    <Path
      d='M38.6666 9.66668H43.5C44.7818 9.66668 46.0112 10.1759 46.9176 11.0823C47.8241 11.9888 48.3333 13.2181 48.3333 14.5V48.3333C48.3333 49.6152 47.8241 50.8446 46.9176 51.751C46.0112 52.6575 44.7818 53.1667 43.5 53.1667H14.5C13.2181 53.1667 11.9887 52.6575 11.0823 51.751C10.1759 50.8446 9.66663 49.6152 9.66663 48.3333V14.5C9.66663 13.2181 10.1759 11.9888 11.0823 11.0823C11.9887 10.1759 13.2181 9.66668 14.5 9.66668H19.3333M17.3995 23.1998H20.2995M17.3995 31.8998H20.2995M17.3995 40.5998H20.2995M28.9995 23.1998H40.5995M28.9995 31.8998H40.5995M28.9995 40.5998H40.5995M21.75 4.83334H36.25C37.5846 4.83334 38.6666 5.91532 38.6666 7.25001V12.0833C38.6666 13.418 37.5846 14.5 36.25 14.5H29H21.75C20.4153 14.5 19.3333 13.418 19.3333 12.0833V7.25001C19.3333 5.91532 20.4153 4.83334 21.75 4.83334Z'
      fill='none'
      stroke='#000000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={4.35}
    />
  </Svg>
)
